import React from 'react';
import { AutocompleteInput, AutocompleteInputProps } from 'react-admin';

const AutoCompleteInput = ({
  source,
  label,
  choices,
  open,
  validate,
  popups,
}: AutocompleteInputProps & { popups: React.ReactNode;
}) => (
  <AutocompleteInput
    source={source}
    fullWidth
    label={label}
    choices={choices}
    open={open}
    autoHighlight
    forcePopupIcon
    validate={validate}
    popupIcon={popups}
    sx={{
      '& .MuiAutocomplete-popupIndicator': {
        '&:hover': {
          backgroundColor: 'transparent',
        },
        transform: 'none',
      },
    }}
  />
);

export default AutoCompleteInput;
